var $7f5044f0e0d68e7e$exports = {};
$7f5044f0e0d68e7e$exports = {
    "decrease": (args)=>`\u{7E2E}\u{5C0F} ${args.fieldLabel}`,
    "increase": (args)=>`\u{653E}\u{5927} ${args.fieldLabel}`,
    "numberField": `\u{6578}\u{5B57}\u{6B04}\u{4F4D}`
};


export {$7f5044f0e0d68e7e$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
